(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rabenberg-home"] && !Shopify.designMode) return;
  try {
    
function setupRabenbergPurchase(){const hero=document.querySelector('.ra-hero');const bar=document.querySelector('.ra-sticky');if(!hero||!bar)return;const observer=new IntersectionObserver(([entry])=>{bar.hidden=entry.isIntersecting||entry.boundingClientRect.top>0;},{threshold:0});observer.observe(hero)}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',setupRabenbergPurchase,{once:true})}else{setupRabenbergPurchase()}
document.addEventListener('shopify:section:load',setupRabenbergPurchase);

  } catch(e) { console.error(e); }
})();
})();
